document.addEventListener('DOMContentLoaded', function () {
	var toggle = document.querySelector('.site-header__mobile-toggle');
	var nav = document.getElementById('site-header-mobile-nav');

	// Items del nav desktop con mega-menu (hover abre/cierra vía JS, no :hover en CSS,
	// para poder cerrar con Escape y no pelear con la transición de salida).
	// Delay corto antes de cerrar: un movimiento rápido del mouse hacia el panel
	// puede pasar un instante por un pixel que no es ni el link ni el panel
	// (redondeo, animación) y no queremos que eso cierre el menú de golpe.
	var menuItems = document.querySelectorAll('.site-header__nav > .item-menu');
	var closeTimer = null;
	menuItems.forEach(function (item) {
		if (!item.querySelector('.mega-menu')) return;
		item.classList.add('has-children');
		item.addEventListener('mouseenter', function (e) {
			e.stopPropagation();
			clearTimeout(closeTimer);
			menuItems.forEach(function (i) { i.classList.remove('active'); });
			item.classList.add('active');
		});
		item.addEventListener('mouseleave', function (e) {
			e.stopPropagation();
			closeTimer = setTimeout(function () {
				item.classList.remove('active');
			}, 150);
		});
	});

	document.addEventListener('keyup', function (e) {
		if (e.key === 'Escape') {
			menuItems.forEach(function (item) { item.classList.remove('active'); });
		}
	});

	var mobileTabs = nav ? nav.querySelectorAll('[data-mobile-tab]') : [];
	var mobilePanels = nav ? nav.querySelectorAll('[data-mobile-panel]') : [];
	mobileTabs.forEach(function (tab) {
		tab.addEventListener('click', function () {
			mobileTabs.forEach(function (t) {
				t.classList.remove('is-active');
				t.setAttribute('aria-selected', 'false');
			});
			mobilePanels.forEach(function (p) { p.classList.remove('is-active'); });
			tab.classList.add('is-active');
			tab.setAttribute('aria-selected', 'true');
			var panel = nav.querySelector('[data-mobile-panel="' + tab.getAttribute('data-mobile-tab') + '"]');
			if (panel) panel.classList.add('is-active');
		});
	});

	// Mobile menu group accordions. Self-contained (not the theme's
	// collapsible-row element): the header renders at the end of <body>,
	// after app.js already ran and defined collapsible-row, so any
	// <collapsible-row> parsed here would upgrade before its own children
	// exist and end up with null internal refs. See git history for details.
	function animateDetails(details, opening, onDone) {
		var summary = details.querySelector('summary');
		var content = details.querySelector('.mobile-menu__group-links');
		if (!summary || !content) {
			details.open = opening;
			if (onDone) onDone();
			return;
		}

		details.style.overflow = 'hidden';
		var startHeight = details.offsetHeight;

		if (opening) details.open = true;
		var endHeight = opening ? summary.offsetHeight + content.offsetHeight : summary.offsetHeight;
		if (opening) details.style.height = startHeight + 'px';

		var animation = details.animate(
			{ height: [startHeight + 'px', endHeight + 'px'] },
			{ duration: opening ? 300 : 250, easing: opening ? 'ease-out' : 'ease' }
		);
		animation.onfinish = function () {
			details.open = opening;
			details.style.height = '';
			details.style.overflow = '';
			if (onDone) onDone();
		};
	}

	var mobileGroupsContainers = nav ? nav.querySelectorAll('.mobile-menu__groups') : [];
	mobileGroupsContainers.forEach(function (container) {
		var detailsList = Array.from(container.querySelectorAll('details'));
		detailsList.forEach(function (details) {
			var summary = details.querySelector('summary');
			if (!summary) return;
			summary.addEventListener('click', function (e) {
				e.preventDefault();
				if (details.open) {
					animateDetails(details, false);
					return;
				}
				detailsList.forEach(function (other) {
					if (other !== details && other.open) animateDetails(other, false);
				});
				animateDetails(details, true);
			});
		});
	});

	if (!toggle || !nav) return;

	var mobileNavClose = nav.querySelector('.site-header__mobile-nav-close');

	function close() {
		const header = document.querySelector('#site-header');
		nav.classList.remove('is-open');
		toggle.setAttribute('aria-expanded', 'false');
		document.body.classList.remove('overflow-hidden');
		setTimeout(function () { header.classList.remove('mix-blend-mode-normal'); }, 300);
	}

	function open() {
		const header = document.querySelector('#site-header');
		if (header) {
			header.classList.add('mix-blend-mode-normal');
		}
		nav.classList.add('is-open');
		toggle.setAttribute('aria-expanded', 'true');
		document.body.classList.add('overflow-hidden');
	}

	toggle.addEventListener('click', function () {
		if (nav.classList.contains('is-open')) {
			close();
		} else {
			open();
		}
	});

	if (mobileNavClose) {
		mobileNavClose.addEventListener('click', close);
	}

	nav.querySelectorAll('a').forEach(function (link) {
		link.addEventListener('click', close);
	});

	document.addEventListener('keyup', function (e) {
		if (e.key === 'Escape') close();
	});

	document.addEventListener('panel:open', function (e) {
		if (e.detail && e.detail.panel && e.detail.panel.classList.contains('search-overlay')) {
			var header = document.querySelector('#site-header');
			if (header) header.classList.add('mix-blend-mode-normal');
		}
	});
	document.addEventListener('panel:closed', function (e) {
		if (e.detail && e.detail.panel && e.detail.panel.classList.contains('search-overlay')) {
			var header = document.querySelector('#site-header');
			if (header) {
				setTimeout(function () { header.classList.remove('mix-blend-mode-normal'); }, 300);
			}
		}
	});
});
